export enum AssessmentHistoryType {
  SKILL_ASSESSMENTS,
  DIAGNOSTIC_ASSESSMENTS,
}

export enum ProgressType {
  SKILLS,
  STUDENTS,
}
